import React from 'react';

const INSIGHTS = [
  "AI isn't a replacement, it's a mirror.",
  "The goal is co-intelligence, not automation.",
  "Humanity is the killer app of the 21st century.",
  "Algorithms lack intent. We provide the 'Why'.",
  "Curiosity is our greatest defensive strategy.",
  "Sensemaking is a communal act.",
  "We are moving from 'Search' to 'Synthesis'.",
  "Technology disappears when it works; humans shouldn't.",
  "Meaning cannot be calculated.",
  "The future is human-led, machine-augmented."
];

const InsightsMarquee: React.FC = () => {
  return (
    <div className="py-12 bg-white border-y border-neutral-100 overflow-hidden relative group pause-marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {/* Double the list to create seamless loop */}
        {[...INSIGHTS, ...INSIGHTS].map((insight, idx) => (
          <div key={idx} className="flex items-center mx-12">
            <span className="text-[10px] font-black uppercase tracking-[0.4em] text-neutral-400">
              {insight}
            </span>
            <div className="w-1.5 h-1.5 bg-terracotta rounded-full ml-12 opacity-30" />
          </div>
        ))}
      </div>
      
      {/* Side gradients for smooth fade */}
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white to-transparent z-10" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-white to-transparent z-10" />
    </div>
  );
};

export default InsightsMarquee;